import { CartItem } from "../utils/interfaces";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";

const usePosMenuGetPriceHook = () => {
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  return (product: CartItem) => {
    return product.price_per_target_value
      ? product.price_per_target_value[deliveryMethod] ?? product.price
      : product.price;
  };
};

export default usePosMenuGetPriceHook;
